import { useCallback } from 'react'

import { apiManager, constants } from 'helpers'
import useAuthDispatch from './useAuthDispatch'

const {
  AUTH_ACTIONS: { UPDATE_USER },
} = constants

const useUpdateCompany = () => {
  const dispatch = useAuthDispatch()

  const update = useCallback(
    async data => {
      const trackUpdatedCompanyValue = (id, name, value) => {
        const properties = { host: id }
        if (value) {
          properties[name] = value
        }
      }

      const checkIfNeedToTrackUpdateOrDelete = (id, name, value) => {
        if (value?.length) {
          trackUpdatedCompanyValue(id, name, value)
        }
      }

      const trackUpdatesInAnalytics = (user, updates) => {
        const { id } = user
        const {
          bannerImage,
          location,
          logo,
          linkId,
          website,
          description,
          name,
          videoLink,
          slogan,
        } = updates

        if (logo) {
          trackUpdatedCompanyValue(id, 'logo')
        }
        if (bannerImage) {
          trackUpdatedCompanyValue(id, 'bannerImage')
        }
        if (linkId) {
          trackUpdatedCompanyValue(id, 'linkId', linkId)
        }
        checkIfNeedToTrackUpdateOrDelete(id, 'companyLocation', location)
        checkIfNeedToTrackUpdateOrDelete(id, 'videoLink', videoLink)
        checkIfNeedToTrackUpdateOrDelete(id, 'companyName', name)
        checkIfNeedToTrackUpdateOrDelete(id, 'companySlogan', slogan)
        checkIfNeedToTrackUpdateOrDelete(id, 'companyWebsite', website)
        checkIfNeedToTrackUpdateOrDelete(id, 'companyDescription', description)
      }
      const response = await apiManager.updateHostProfileData(data)
      dispatch({ type: UPDATE_USER, payload: response })
      trackUpdatesInAnalytics(response, data)
      return response
    },
    [dispatch]
  )

  return update
}

export default useUpdateCompany
